import { render, staticRenderFns } from "./roomDetail.vue?vue&type=template&id=6f2cacc0&scoped=true"
import script from "./roomDetail.vue?vue&type=script&lang=js"
export * from "./roomDetail.vue?vue&type=script&lang=js"
import style0 from "./roomDetail.vue?vue&type=style&index=0&id=6f2cacc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2cacc0",
  null
  
)

export default component.exports